import { useAccountStore } from "@/stores/account";
import { useAdminStore } from "@/stores/admin";
import { useApplicationsStore } from "@/stores/applications";
import { useBulkApplyStore } from "@/stores/bulkApply";
import { useBillingStore } from "@/stores/billing";
import { useConnectedServicesStore } from "@/stores/connectedServices";
import { useHistoryStore, useReviewStore } from "@/stores/candidatePages";
import { useDocumentEditorStore } from "@/stores/documentEditor";
import { useDocumentsStore } from "@/stores/documents";
import { useInboxStore, useWishlistStore } from "@/stores/inboxWishlist";
import { useMentorsStore } from "@/stores/mentors";
import { useProfileStore } from "@/stores/profile";
import { useRolesStore } from "@/stores/roles";
import { useRuntimeErrorStore } from "@/stores/runtimeError";
import { useSkilledWorkerStore } from "@/stores/skilledWorker";

export function resetSessionState(): void {
  useApplicationsStore().reset();
  useBulkApplyStore().reset();
  useBillingStore().reset();
  useConnectedServicesStore().reset();
  useRolesStore().reset();
  useDocumentEditorStore().reset();
  useReviewStore().reset();
  useHistoryStore().reset();
  useDocumentsStore().reset();
  useInboxStore().reset();
  useWishlistStore().reset();
  useMentorsStore().reset();
  useSkilledWorkerStore().reset();
  useProfileStore().reset();
  useAccountStore().reset();
  useAdminStore().reset();
  useRuntimeErrorStore().clear();
}
